export default __webpack_public_path__ + "static/media/1620935111751_image0.dfad7c5a.jpeg";